export default function validation(response, messages) {
  response.data.error.validationErrors.forEach((error) => {
    const message = error.message;
    if (message !== null) {
      if (message.indexOf('PRODUCT_INCLUDE_IN_REGROUPEMENT') === 0) {
        const splitMessage = message.split('|')[0].split('@');
        messages.push({
          message: 'addEditRegroupementProduit.error.productIncludeInRegroupement',
          parametres: {
            name: splitMessage[1],
          },
        });
      }
    }
  });
}
